export default "__VITE_ASSET__BMKHmQnr__"